import { DecodedResponseChunk } from '@/pages/ISWAN_CHAT/utils/decodeResponseChunk';
import { CheckCircleOutlined, InfoCircleOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { ThoughtChainItem } from '@ant-design/x';
import markdownit from 'markdown-it';

const md = markdownit({ html: true, breaks: true });

export const renderMarkdown = (content: string) => (
  <div style={{ all: 'unset' }}>
    <div className={'markdown-body __fix__markdown_body'}>
      <div dangerouslySetInnerHTML={{ __html: md.render(content) }} />
    </div>
  </div>
);

function getStatusIcon(chunk: DecodedResponseChunk) {
  if (chunk.type === 'error') {
    return <InfoCircleOutlined />;
  }

  switch ('status' in chunk && chunk.status) {
    case 'success':
      return <CheckCircleOutlined />;
    case 'error':
      return <InfoCircleOutlined />;
    case 'pending':
      return <PlayCircleOutlined />;
    default:
      return undefined;
  }
}

export function buildThoughtChain(chunkDataList: DecodedResponseChunk[]): ThoughtChainItem[] {
  // const chunkList = chunkDataList.filter((e)  => e.type === 'message')

  const resList: ThoughtChainItem[] = [];

  chunkDataList.forEach((chunk, index) => {
    if (chunk.type === 'ping') {
      return;
    }

    const getTitle = () => {
      if (chunk.type === 'message') {
        return '来自LLM的回复';
      }

      if ('title' in chunk) {
        return chunk.title;
      } else {
        return '工作节点' + (index + 1);
      }
    };

    const getDescription = () => {
      const dict__description = {
        pending: '节点状态：开始',
        success: '节点状态：成功',
        error: '节点状态：失败',
      };

      if ('description' in chunk && chunk.description !== undefined) {
        return chunk.description;
      }

      if ('status' in chunk) {
        const status = chunk.status;
        return dict__description[status];
      }

      if (chunk.type === 'error') {
        return dict__description['error'];
      }

      return dict__description['success'];
    };

    const getContent = () => {
      if ('text' in chunk) {
        return renderMarkdown(chunk.text);
      }

      if ('content' in chunk && chunk.content !== undefined) {
        return renderMarkdown(chunk.content);
      }

      return '';
    };

    const getStatus = () => {
      if (chunk.type === 'error') {
        return 'error';
      }

      return 'status' in chunk ? chunk?.status : 'success';
    };

    resList.push({
      title: getTitle(),
      description: getDescription(),
      content: getContent(),
      icon: getStatusIcon(chunk),
      status: getStatus(),
    });
  });

  return resList;
}
